// Reduz a imagem no navegador (lado maior até `max` px, JPEG) antes de enviar — devolve data URL
export function reduzirImagem(arquivo: File, max = 1280): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const escala = Math.min(1, max / Math.max(img.width, img.height))
      const canvas = document.createElement('canvas')
      canvas.width = Math.round(img.width * escala)
      canvas.height = Math.round(img.height * escala)
      canvas.getContext('2d')!.drawImage(img, 0, 0, canvas.width, canvas.height)
      URL.revokeObjectURL(img.src)
      resolve(canvas.toDataURL('image/jpeg', 0.85))
    }
    img.onerror = () => reject(new Error('Não foi possível ler a imagem.'))
    img.src = URL.createObjectURL(arquivo)
  })
}
